// import React, { useEffect, useRef } from 'react';
// import { ReactComponent as SadanIcon } from '../../assets/sadan 2020.svg';


// function Logo({ mapWidth, mapHeight, onLogoClick }) { 
//     const containerRef = useRef(null); 
//     const handleClick = (e) => {
//         e.stopPropagation(); 
//         onLogoClick(e); 
//     };

//     useEffect(() => {
//         if (!containerRef.current) {
//             return;
//         }
//         const svgElement = containerRef.current.querySelector('svg');
//         if (!svgElement) {
//             return;
//         }
//         const clickablePath = svgElement.querySelector('#clickable-shape'); 

//         if (!clickablePath) {
//             return;
//         }
//         clickablePath.addEventListener('click', handleClick);
//         clickablePath.style.pointerEvents = "auto";
//         clickablePath.style.cursor = "pointer";

//         return () => {
//             if (clickablePath) { 
//                 clickablePath.removeEventListener('click', handleClick);
//             }
//         };
//     }, [onLogoClick]);

//     return (
//         <div 
//             ref={containerRef}
//             style={{
//                 position: "absolute",
//                 width: mapWidth, 
//                 height: mapHeight,
//                 cursor: "pointer", 
//             }}
//         >
//             <SadanIcon
//                 style={{
//                     width: '100%', 
//                     height: '100%',
//                     display: 'block',
//                     pointerEvents: "none" 
//                 }}
//             />
//         </div>
//     );
// }

// export default Logo;











// import React from "react";
// import { useProjectMap } from "../../api/main_Map/useProjectMap";
// import { BASE_URL_IMG } from "../../api/apiConfig";

// // function Logo({ mapWidth, mapHeight, onLogoClick }) {
// //   const { projectData, loading } = useProjectMap("sadan") || {};

// //   if (loading || !projectData?.logo) return null;

// //   const logoImage = `${BASE_URL_IMG}/${projectData.logo}`;

// //   const handleClick = (e) => {
// //     e.stopPropagation();
// //     onLogoClick?.(e);
// //   };

// //   return (
// //     <div
// //       onClick={handleClick}
// //       style={{
// //         position: "absolute",
// //         inset: 0,
// //         width: mapWidth,
// //         height: mapHeight,
// //         cursor: "pointer",
// //         pointerEvents: "none",
// //       }}
// //     >
// //       <img
// //         src={logoImage}
// //         alt="Project Logo"
// //         draggable={false}
// //         style={{
// //           width: "100%",
// //           height: "100%",
// //           objectFit: "contain",
// //           pointerEvents: "auto", 
// //         }}
// //       />
// //     </div>
// //   );
// // }
// function Logo({ mapWidth, mapHeight, onLogoClick }) {
//   const { projectData, loading } = useProjectMap("sadan") || {};

//   if (loading || !projectData?.logo) return null;

//   const handleClick = (e) => {
//     e.stopPropagation();
//     onLogoClick?.(e);
//   };

//   return (
//     <div
//       onClick={handleClick}
//       style={{
//         position: "absolute",
//         inset: 0,
//         width: mapWidth,
//         height: mapHeight,
//         cursor: "pointer",
//         zIndex: 10, // تأكد من أنه فوق العناصر الأخرى
//       }}
//       // هنا نقوم بحقن كود الـ SVG مباشرة
//       dangerouslySetInnerHTML={{ __html: projectData.logo }}
//     />
//   );
// }
// export default Logo;
import React from "react";
import { useProjectMap } from "../../api/main_Map/useProjectMap";

function Logo({ mapWidth, mapHeight, onLogoClick }) {
  const { projectData, loading } = useProjectMap("sadan") || {};

  if (loading || !projectData?.logo) return null;

  const handleTrigger = (e) => {
    // كونسول إجباري عشان نقطع الشك باليقين
    console.log("!!! LOGO TRIGGERED !!! via", e.type);
    
    e.stopPropagation(); // منع الخريطة من إنها تعمل Drag
    if (onLogoClick) onLogoClick(e);
  };

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        width: mapWidth,
        height: mapHeight,
        zIndex: 9999, // رفع الطبقة جداً
        pointerEvents: "none", 
      }}
    >
      <div
        onMouseDown={handleTrigger} // للكمبيوتر
        onTouchStart={handleTrigger} // للموبايل
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
        }}
        dangerouslySetInnerHTML={{
          __html: projectData.logo
            .replace("<svg", `<svg style="width: 100%; height: 100%; pointer-events: none;"`)
            .replace(
              /<path|<rect|<circle|<polygon/g,
              (match) => `${match} style="pointer-events: auto; cursor: pointer;"`
            ),
        }}
      />
    </div>
  );
}

export default Logo;